export default "__VITE_ASSET__CKW0Jsrc__"